import { Injectable } from '@angular/core';
import { IColorCode, IColorData } from '@se/ui.anatomic.map';
import { ICpEntity } from '../../cp-configuration/view-model';
import { ICpDescription } from './models/ICpDescription';
import { DataBinding } from '@se/se.platform.base';
import { IDataSourceItem } from '@se/cp.common';

@Injectable({
    providedIn: 'root',
})
export class CpMapParsers {

    private _getColorById (legend : IColorCode [], colorID : string | undefined) : IColorCode {
        if (colorID === '' || colorID === undefined) return legend[0];
        else return legend.filter((val) => {
            return val.colorID === colorID;
        })[0];
    }

    parseColor(item: IDataSourceItem | ICpEntity): IColorCode {
        const colorID = item.getPropertyPrimitiveValue('Id') as string;
        const description = item.getPropertyPrimitiveValue('Description') as string;
        const order = item.getPropertyPrimitiveValue('Order') as number;
        const alphaCode = item.getPropertyPrimitiveValue('Code') as string;
        const score = item.getPropertyPrimitiveValue('Score') as number;
        const color = item.getPropertyPrimitiveValue('Color') as string;
        const IsNormality = item.getPropertyPrimitiveValue('IsNormality') as boolean;
        return { colorID, description, color, alphaCode, order, score, IsNormality };
    }

    parseRegionDescription(descItem: IDataSourceItem): ICpDescription {
        const id = descItem.Id;
        const regionID = descItem.getPropertyPrimitiveValue('RegionID') as string;
        const order = descItem.getPropertyPrimitiveValue('Order') as number;
        const code = descItem.getPropertyPrimitiveValue('Code') as string;
        // recuperata DescriptionForPrint OR Description
        // per mantenere la compatibilità con la vecchia Description ma
        // dando la precedenza alla nuova proprietà DescriptionForPrint
        const descriptionForPrint = descItem.getPropertyPrimitiveValue('DescriptionForPrint') as string;
        const description = descItem.getPropertyPrimitiveValue('Description') as string;
        return { id: id,
                regionID: regionID,
                code: code,
                order: order,
                description: descriptionForPrint ?? description,
        };
    }


    // parseColorData(cpData: ICpColorData[], colorCodes: IColorCode[], descriptions?: ICpDescription[]): IColorData[] {
    //     return cpData.map((cpData) => {

    //         const code = colorCodes.find((c) => c.colorID === cpData.colorID) as IColorCode;
    //         const output: IColorData = {
    //             ...code,
    //             regionID: cpData.regionID,
    //         };
    //         if (descriptions && descriptions.length > 0) {
    //             output.segmentDescription = descriptions.find(desc => desc.regionID === cpData.regionID)?.description || ''
    //         }
    //         return output
    //     });
    // }

    parseRegionsValue(entity: ICpEntity, regions: ICpDescription[], legend : IColorCode [], fallbackColorId?: string): IColorData[] {
        let output: IColorData[] = [];

        entity.forOwn((key) => {

            const filteredRegions : ICpDescription [] = regions.filter (reg => {
                return reg.regionID === key;
            });

            const isRegionKey: boolean = (filteredRegions.length === 1);

            if (isRegionKey) {
                const regionDesc = filteredRegions[0].description;
                const regionDataBinding = new DataBinding(key)
                const colorEntity = entity.getSelectedEntity(regionDataBinding);
                const id = colorEntity?.getPropertyPrimitiveValue ('Id')?.toString();
                const color : IColorCode = (colorEntity) ? this._getColorById (legend, id) : this._getColorById (legend, fallbackColorId);

                output.push({
                    ...color,
                    regionID: key,
                    segmentDescription : regionDesc
                });
            }
        });

        return output
    }
}
